
import { Options, prop, Vue } from "vue-class-component";
import Skeleton from "@/app/ui/components/skeleton/index.vue";
import CheckBox from "@/app/ui/components/check-box/index.vue";

class Props {
  options = prop<Array<any>>({
    default: [],
    type: Array
  });
  errorDataShow = prop<Array<any>>({
    default: [],
    type: Array
  });
  optionName = prop<string>({
    default: "Item",
    type: String
  });
  modelValue = prop<Array<any>>({
    default: [],
    type: Array
  });
  isDisabled = prop<boolean>({
    default: false,
    type: Boolean
  });
  disableBackground = prop<boolean>({
    default: false,
    type: Boolean
  });
  allEnabled = prop<boolean>({
    default: false,
    type: Boolean
  });
  isLoading = prop<boolean>({
    default: false,
    type: Boolean
  });
  isError = prop<boolean>({
    default: false,
    type: Boolean
  });
  placeholder = prop<string>({
    default: "",
    type: String
  });
  keyName = prop<string>({
    default: "name",
    type: String
  });
  keyValue = prop<string>({
    default: "value",
    type: String
  });
  modalTitle = prop<string>({
    default: "",
    type: String
  });
  maxItemDisplayed = prop<number>({
    default: 999,
    type: Number
  });
  closeOnSelecting = prop<boolean>({
    default: false,
    type: Boolean
  });
  error = prop<boolean>({
    default: false,
    type: Boolean
  });
  errorCaption = prop<string>({
    default: "",
    type: String
  });
  serverSide = prop<boolean>({
    default: true,
    type: Boolean
  });
  showReset = prop<boolean>({
    default: false,
    type: Boolean
  });
  showSelected = prop<boolean>({
    default: true,
    type: Boolean
  });
  showSelectedInInput = prop<boolean>({
    default: false,
    type: Boolean
  });
  hideInput = prop<boolean>({
    default: false,
    type: Boolean
  });
  ableToDeleteInModal = prop<boolean>({
    default: false,
    type: Boolean
  });
  displayValue = prop<boolean>({
    default: false,
    type: Boolean
  });
  customDisplayAll = prop<string>({
    default: "Pilih Semua",
    type: String
  });
  noteForBosspack = prop<boolean>({
    default: false,
    type: Boolean
  });
  disabledBosspack = prop<boolean>({
    default: false,
    type: Boolean
  });
  customSelectedItem = prop<boolean>({
    default: false,
    type: Boolean
  });
  customSelectedItemText = prop<string>({
    default: "Status",
    type: String
  });
  useInfiniteScroll = prop<boolean>({
    default: false,
    type: Boolean
  });
}

@Options({
  emits: [
    "focus",
    "blur",
    "change",
    "filter",
    "reset",
    "update:isError",
    "remove",
    "scrolled"
  ],
  components: {
    Skeleton,
    CheckBox
  },
  directives: {
    "click-outside": {
      beforeMount: function(el: any, binding: any) {
        const ourClickEventHandler = (event: any) => {
          if (!el.contains(event.target) && el !== event.target) {
            binding.value(event);
          }
        };
        el.__vueClickEventHandler__ = ourClickEventHandler;
        document.addEventListener("click", ourClickEventHandler);
      },
      unmounted: function(el: any) {
        document.removeEventListener("click", el.__vueClickEventHandler__);
      }
    }
  },
  watch: {
    modelValue() {
      this.$emit("update:isError", !this.modelValue.length);
    }
  }
})
export default class Select extends Vue.with(Props) {
  // logic open close menu
  isChevron = false;
  isOpenMenu = false;
  onOpenSelect(value: boolean) {
    if (value) {
      this.$emit("focus", "");
    }
    if (!value) {
      this.filterSearch = "";
      this.$emit("blur", "");
    }
    this.isOpenMenu = value;
  }

  // Handler for click outside
  onClickOutside(e: Event): void {
    if (this.isChevron) {
      (this.$refs.selectSearch as HTMLInputElement)?.focus();
      this.isChevron = false;
    } else if (this.isOpenMenu) {
      e.preventDefault();
      this.onOpenSelect(false);
    }
  }

  modelDialog = false;

  // Helper to get display text for string items
  private getDisplayTextForString(item: string): string {
    const option = this.options.find(
      (opt: any) => opt[this.keyValue] === item || opt[this.keyName] === item
    );
    return option ? option[this.keyName] : item;
  }

  // Helper to get display text for object items
  private getDisplayTextForObject(item: any): string {
    if (this.displayValue) {
      return item[this.keyValue] || item.value || String(item);
    }
    return (
      item[this.keyName] ||
      item.name ||
      item[this.keyValue] ||
      item.value ||
      String(item)
    );
  }

  // Helper to get display text for chips
  getDisplayText(item: any): string {
    if (typeof item === "string") {
      return this.getDisplayTextForString(item);
    }
    if (item && typeof item === "object") {
      return this.getDisplayTextForObject(item);
    }
    return String(item);
  }

  // Helper to check if item is "all"
  private isItemAll(item: any): boolean {
    if (typeof item === "string") {
      return item.toLowerCase() === "all";
    }
    if (item && typeof item === "object") {
      return (
        item[this.keyValue]?.toLowerCase() === "all" ||
        item.value?.toLowerCase() === "all"
      );
    }
    return false;
  }

  // Helper to find "all" option from options
  private findAllOption(): any {
    return this.options.find(
      (opt: any) =>
        opt[this.keyValue]?.toLowerCase() === "all" ||
        opt.value?.toLowerCase() === "all"
    );
  }

  // Helper to get all option display name
  private getAllOptionDisplayName(): string {
    const allOption = this.findAllOption();
    return allOption
      ? allOption[this.keyName] || allOption.name || "Semua"
      : "Semua";
  }

  //logic filter search
  get selectedItemsName() {
    if (this.modelValue.length === 0) {
      return "";
    }
    // Check if "ALL" is selected
    const isAllSelected = this.modelValue.some((item: any) =>
      this.isItemAll(item)
    );

    if (isAllSelected) {
      return this.getAllOptionDisplayName();
    }

    if (this.customSelectedItem) {
      return `${this.modelValue.length} ${this.customSelectedItemText}`;
    }

    return this.modelValue
      .map((item: any) => item[this.keyName] || item.name)
      .join(", ");
  }
  filterSearch = "";
  get dataOptions() {
    // Always apply client-side filtering for options that are already loaded
    const tempOptions = this.options.filter((option: any) => {
      if (!this.filterSearch) {
        return true;
      }
      return option[this.keyName]
        ? option[this.keyName]
            .toLowerCase()
            .includes(this.filterSearch.toLowerCase())
        : option.toLowerCase().includes(this.filterSearch.toLowerCase());
    });

    // Add "All" option if enabled and no search filter
    if (this.allEnabled && !this.filterSearch) {
      const allObject: any = {};
      allObject[this.keyName] = "All";
      allObject[this.keyValue] = "all";
      tempOptions.unshift(allObject);
    }

    return tempOptions;
  }
  onSearch() {
    this.$emit("filter", this.filterSearch);
  }

  // logic for selected item
  isSelected(item: any) {
    if (`${item[this.keyValue]}`.toLowerCase() === "all" && this.allEnabled) {
      return this.isAll();
    }
    return this.modelValue.find((data: any) => {
      return data[this.keyValue]
        ? data[this.keyValue] === item[this.keyValue]
        : data === item;
    });
  }
  isAll() {
    return (
      (this.modelValue.length === this.options.length && this.allEnabled) ||
      !!this.modelValue?.find(
        (item: any) => `${item[this.keyValue]}`.toLowerCase() === "all"
      )
    );
  }
  // Helper to check if should replace all selection
  private shouldReplaceAllSelection(item: any): boolean {
    if (this.allEnabled) {
      return false;
    }
    const isItemAll = `${item[this.keyValue]}`.toLowerCase() === "all";
    const currentlyAll = this.isAll();
    return (
      (currentlyAll && !isItemAll) ||
      (!currentlyAll && this.modelValue.length > 0 && isItemAll)
    );
  }

  // Helper to handle item selection/deselection
  private toggleItemSelection(item: any, index: number): void {
    if (this.isSelected(item)) {
      const indexItemSelected = this.modelValue.findIndex((data: any) =>
        data[this.keyValue]
          ? data[this.keyValue] === item[this.keyValue]
          : data === item
      );
      this.$emit("remove", item, index);
      this.modelValue.splice(indexItemSelected, 1);
    } else {
      this.modelValue.push(item);
    }
  }

  onChooseSelect(item: any, index: number) {
    if (this.shouldReplaceAllSelection(item)) {
      this.modelValue.splice(0, this.modelValue.length);
      this.modelValue.push(item);
      this.$emit("change", [item]);
      return;
    }
    if (`${item[this.keyValue]}` === "all" && this.allEnabled) {
      this.onChooseAll();
      return;
    }
    this.toggleItemSelection(item, index);
    this.$emit("change", this.modelValue);
    this.$emit("update:isError", !this.modelValue.length);
  }
  onChooseAll() {
    if (this.isAll()) {
      this.modelValue.splice(0, this.modelValue.length);
    } else {
      this.modelValue.splice(0, this.modelValue.length);
      for (const option of this.options) {
        this.modelValue.push(option);
      }
    }
    this.$emit("change", this.modelValue);
  }

  get filterShowValue(): any[] {
    const data = this.modelValue.slice(0, this.maxItemDisplayed);
    if (this.errorDataShow.length) {
      return data.map((item: any) => {
        const find = this.errorDataShow.find(
          (el: any) => el[this.keyValue] === item[this.keyValue]
        );
        if (find) {
          return { ...item, isError: true };
        }
        return item;
      });
    }
    return data;
  }

  onReset() {
    this.$emit("change", []);
    this.$emit("reset", "");
  }

  fetchNew({ target: { scrollTop } }: any) {
    if (scrollTop > 0 && this.useInfiniteScroll) {
      this.$emit("scrolled", this.filterSearch);
    }
  }
}
